import API from './lenderAPI';

import {
  GET_LENDER_LISTING_DATA,
} from '../../types';

export const LenderListing = () => async (dispatch) => {
  const lenderListings = await API.getLenderListing();
  dispatch({
    type: GET_LENDER_LISTING_DATA,
    payload: lenderListings[0],
  });
};

export default LenderListing;
